import type { TFunction } from 'i18next';

import { PaymentFormEnum } from '@mopla/data-models';

import { ILegPaymentStatus } from './types';

/**
 * Key is `<paymentState>_<paymentForm>`, falling back to the bare state for
 * combinations with no translation — `PAID` and `FAILED` have no per-form wording.
 */
export const getLegPaymentStatusText = (
	payment: ILegPaymentStatus | null | undefined,
	t: TFunction
): string | null => {
	if (!payment) {
		return null;
	}

	return payment.paymentForm === PaymentFormEnum.NOT_NEEDED
		? t('booking:payment.status_summary.NOT_NEEDED')
		: t(`booking:payment.status_summary.${payment.paymentState}`, {
				context: payment.paymentForm,
		  });
};
